const Actions = ({ label, actions, variant = "outlined", body }) => {
  return (
    <div className="miltis-actions">
      <div className="miltis-actions__container">
        <div className="miltis-actions__label">
          <span dangerouslySetInnerHTML={{ __html: label }}></span>
        </div>
        <div className="miltis-actions__buttons">{actions}</div>
      </div>
      {body && <div className="miltis-actions__body">{body}</div>}
    </div>
  );
};

export default Actions;
